// Form field types
export enum FormFieldType {
  TEXT = 'text',
  EMAIL = 'email',
  PHONE = 'phone',
  NUMBER = 'number',
  TEXTAREA = 'textarea',
  SELECT = 'select',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  DATE = 'date',
  FILE = 'file',
  MULTI_SELECT = 'multi-select'
}

// Validation rule types
export enum ValidationType {
  REQUIRED = 'required',
  MIN_LENGTH = 'minLength',
  MAX_LENGTH = 'maxLength',
  EMAIL_FORMAT = 'emailFormat',
  PHONE_FORMAT = 'phoneFormat',
  MIN_VALUE = 'minValue',
  MAX_VALUE = 'maxValue',
  PATTERN = 'pattern',
  CUSTOM = 'custom'
}

// Validation rule interface
export interface ValidationRule {
  type: ValidationType;
  value?: any;
  message: string;
  customValidator?: (value: any) => boolean;
}

// Form field option for select/radio fields
export interface FormFieldOption {
  label: string;
  value: string;
  disabled?: boolean;
}

// Base form field interface
export interface FormField {
  id: string;
  name: string;
  label: string;
  type: FormFieldType;
  placeholder?: string;
  helperText?: string;
  defaultValue?: any;
  options?: FormFieldOption[];
  validationRules?: ValidationRule[];
  disabled?: boolean;
  required?: boolean;
  conditional?: {
    dependsOn: string;
    showWhen: any;
  };
}

// Form section interface
export interface FormSection {
  id: string;
  title: string;
  description?: string;
  fields: FormField[];
  order: number;
}

// Complete form configuration
export interface FormConfiguration {
  id: string;
  title: string;
  description?: string;
  sections: FormSection[];
  submitButtonText: string;
  cancelButtonText?: string;
  successMessage: string;
  errorMessage: string;
  externalUrl?: string;
}

// Generic form data submission
export interface FormSubmissionData {
  [fieldName: string]: any;
}

// Form validation result
export interface ValidationResult {
  isValid: boolean;
  errors: Record<string, string>;
}
